import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__F9pqz","info":"styles_info__xo8XT","error":"styles_error__-9x+P","success":"styles_success__fzyXV","warning":"styles_warning__dVIoZ","invert":"styles_invert__d3pie","arrow":"styles_arrow__-6PCU"};
export const b = b_.with('tooltip');